import { z } from 'zod';
export const EmailRuleMatchTypeSchema = z.enum([
    'FROM_DOMAIN',
    'FROM_ADDRESS',
    'TO_DOMAIN',
    'TO_ADDRESS',
    'SUBJECT_CONTAINS',
]);
export const EmailRuleMatchTypeLabel = {
    FROM_DOMAIN: 'Dominio remitente',
    FROM_ADDRESS: 'Email remitente',
    TO_DOMAIN: 'Dominio destinatario',
    TO_ADDRESS: 'Email destinatario',
    SUBJECT_CONTAINS: 'Asunto contiene',
};
export const EmailRuleActionTypeSchema = z.enum(['ARCHIVE_TO_CLIENT', 'ARCHIVE_TO_CASE']);
export const CreateEmailRuleSchema = z.object({
    accountId: z.string().nullable().optional(),
    name: z.string().min(2).max(100),
    matchType: EmailRuleMatchTypeSchema,
    matchValue: z.string().min(1).max(200),
    actionType: EmailRuleActionTypeSchema,
    actionTargetId: z.string().min(1),
    priority: z.coerce.number().int().min(0).max(10000).default(100),
    isEnabled: z.boolean().default(true),
});
export const UpdateEmailRuleSchema = CreateEmailRuleSchema.partial();
export const EmailRuleDtoSchema = z.object({
    id: z.string(),
    accountId: z.string().nullable(),
    name: z.string(),
    matchType: EmailRuleMatchTypeSchema,
    matchValue: z.string(),
    actionType: EmailRuleActionTypeSchema,
    actionTargetId: z.string(),
    actionTargetLabel: z.string(),
    priority: z.number().int(),
    isEnabled: z.boolean(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=email-rules.js.map